import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';

import Box from '../box/box.jsx';
import Dots from './dots.jsx';
import helpIcon from './icons/help.svg';
import backIcon from './icons/back.svg';
import bluetoothIcon from './icons/bluetooth.svg';
import scratchLinkIcon from './icons/scratchlink.svg';
import cancelIcon from './icons/cancel.svg';
import errorIcon from './icons/error.png';

import styles from './connection-modal.css';

const UnavailableStep = props => (
    <Box className={styles.body}>
        <Box className={styles.activityArea}>
            <div className={styles.scratchLinkHelp}>
                <div className={styles.scratchLinkHelpStep}>
                    <div className={styles.errorIcon}>
                        <img
                            className={styles.errorIcon}
                            src={errorIcon}
                        />
                    </div>
                </div>
            </div>
        </Box>
        <Box className={styles.bottomArea}>
            <Box className={classNames(styles.bottomAreaItem, styles.buttonRow)}>
                <button
                    className={styles.connectionButton}
                    onClick={props.onCancel}
                >
                    <img
                        className={styles.buttonIconLeft}
                        src={cancelIcon}
                    />
                    <FormattedMessage
                        defaultMessage="Cancel"
                        description="Cancel"
                        id="gui.connection.unavailable.cancelbutton"
                    />
                </button>
            </Box>
        </Box>
    </Box>
);

UnavailableStep.propTypes = {
    onHelp: PropTypes.func,
    onScanning: PropTypes.func,
    onCancel: PropTypes.func
};

export default UnavailableStep;
